<template>
    <div>
        <div class="dialog-button">
            <el-button v-if="this.readonly" class="green" title="添加组件" @click="fastAddData" icon="el-icon-fa-plus">添加组件</el-button>
            <el-button v-if="this.readonly" class="red" title="删除组件" @click="multiDelete" icon="el-icon-fa-trash">删除组件</el-button>
        </div>
        <PageTable hideTitle hideExport ref="dataTable" :data="dataTable" @load-data="dataTableLoad"
                   @selection-change="handleSelectionChange" highlight-current-row stripe border>
            <el-table-column v-if="this.readonly" type="selection" align='center' width="50"></el-table-column>
            <el-table-column prop="rcorder" label="组件执行顺序" width="160" align='center' show-overflow-tooltip>
                <template slot-scope='scope'>
                    <span v-if="!scope.row.isEdit">{{ scope.row.rcorder }}</span>
                    <el-input-number size="mini" v-model="scope.row.rcorder" :min="1" :max="10" v-if="scope.row.isEdit"></el-input-number>
                </template>
            </el-table-column>

            <el-table-column prop="cmuuid" label="执行组件名称" align='center' show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-select filterable placeholder="选择组件" v-model="scope.row.cmuuid" v-if="scope.row.isEdit">
                        <el-option
                            v-for="item in coms"
                            :key="item.cmname"
                            :label="item.cmname + ' - [ ' + item.cmdefn + ' ]'"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                    <el-select filterable placeholder="选择组件" v-model="scope.row.cmuuid" disabled v-if="!scope.row.isEdit">
                        <el-option
                            v-for="item in coms"
                            :key="item.cmname"
                            :label="item.cmname + ' - [ ' + item.cmdefn + ' ]'"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed='right' width="120" align="center" v-if="this.readonly">
                <template slot-scope="scope">
                    <el-button v-if='!scope.row.isEdit' title="修改" class="blue" icon="el-icon-edit" @click="fastEditData(scope.row)">修改
                    </el-button>
                    <el-button v-if='scope.row.isEdit' title="确认" class="blue" icon="el-icon-fa-save" @click="fastConfirm(scope.row)">确认
                    </el-button>
                    <el-button v-if='scope.row.isEdit' title="取消" class="yellow" icon="el-icon-close"
                               @click="fastCancel(scope.$index,scope.row)">取消
                    </el-button>
                    <el-button v-if='!scope.row.isEdit' title="删除" class="red" icon="el-icon-delete" @click="fastDelete(scope.$index
                    ,scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </PageTable>


    </div>
</template>

<script>

import BizChainApi from "./BizChain";

const default_com_data = {
    bizuuid: '',
    cmuuid: '',
    rcorder: 0,
    isEdit: true
};

export default {
    props: {
        value: "",
        readonly:null
    },
    async mounted() {
        BizChainApi.getDxpComs().then(resp => {
            this.coms = resp.datarows;
        });
        this.$refs.dataTable.load();
    },
    data() {
        return {
            selection: [],
            dataTable: [],
            coms: [],
        }
    },
    methods: {
        // 查询
        dataTableLoad(params, resolve) {
            var biz_uuid = this.value;
            BizChainApi.listBizCom({biz_uuid})
                .then(resolve) // 让表格解析你提供的数据 (主要解析页码等)
                .then(respData => {
                    if (respData.datarows) {
                        let datarows = [];
                        for (let row in respData.datarows) {
                            respData.datarows[row].isEdit = false;
                            datarows.push(row)
                        }
                        this.dataTable = respData.datarows;
                    }
                });
        },
        handleSelectionChange(selection) {
            this.selection = selection.map(v => v.uuid);
        },
        async multiDelete() {
            await this.confirm();
            await BizChainApi.deleteBizCom({ids: this.selection}).then(() => {
                this.$refs.dataTable.load();
            });
        },
        //-----------------------表格快速编辑开始---------------------------------
        // 快速添加数据
        fastAddData() {
            var copydata = default_com_data;
            copydata.rcorder = this.dataTable.length + 1;
            this.dataTable.push(Object.assign({}, copydata));
        },
        // 快速编辑
        fastEditData(row) {
            this.copyData = Object.assign({}, row);
            row.isEdit = true;
        },
        //确认提交
        async fastConfirm(row) {
            if (!row.rcorder && !row.cmuuid) {
                this.$message.warning("请补全数据!");
                return;
            }
            try {
                await BizChainApi.saveBizCom({
                    bizUuid: this.value,
                    cmUuid: row.cmuuid,
                    rcOrder: row.rcorder,
                    opcomment: '',
                });
                row.isEdit = false;
                this.copyData = null;
                this.$refs.dataTable.load();
            } catch ( e ) {
                this.$message.error(e.respCode);
            }
        },
        //取消提交
        fastCancel(index, row) {
            if (this.copyData) {
                Object.assign(row, this.copyData);
                this.copyData = null;
            } else {
                this.dataTable.splice(index, 1);
            }
        },
        //删除记录
        async fastDelete(index, row) {
            if (row.uuid) {
                await BizChainApi.deleteBizCom({ids: [row.uuid]});
                this.$refs.dataTable.load();
            } else {
                this.dataTable.splice(index, 1);
            }
        },
        //-----------------------表格快速编辑结束---------------------------------
    }
}
</script>

<style scoped>

</style>